import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { Pin, ExternalLink, CheckCheck } from "lucide-react";
import api from "@/lib/api";

const fmt = d => { try { return format(parseISO(d), "d MMM yyyy · HH:mm"); } catch { return d; } };

export default function Notices() {
  const [data, setData] = useState(null);
  const load = () => api.get("/notices").then(r => setData(r.data)).catch(() => setData({ notices: [], unread: 0 }));
  useEffect(() => { load(); }, []);
  const markRead = async (n) => { if (n.read) return; await api.post(`/notices/${n.id}/read`).catch(() => {}); load(); window.dispatchEvent(new Event("notices-changed")); };
  const readAll = async () => { await api.post("/notices/read-all").catch(() => {}); load(); window.dispatchEvent(new Event("notices-changed")); };
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 space-y-6" data-testid="notices-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#83B68B]">From the committee</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl mt-1">Notices</h1>
          <p className="opacity-60 text-sm mt-1">Club news and internal announcements.</p>
        </div>
        {data?.unread > 0 && <button type="button" onClick={readAll} data-testid="notices-read-all" className="text-[10px] tracking-widest uppercase inline-flex items-center gap-1 opacity-70 hover:opacity-100"><CheckCheck className="w-3 h-3" /> Mark all read</button>}
      </div>
      {!data ? <div className="opacity-50 font-display tracking-widest">LOADING…</div>
        : data.notices.length === 0 ? <div className="card-tactical rounded-md p-10 text-center opacity-60" data-testid="notices-empty">No notices yet.</div>
        : (
          <div className="space-y-3" data-testid="notices-list">
            {data.notices.map(n => (
              <article key={n.id} onClick={() => markRead(n)} className={`card-tactical rounded-md p-5 cursor-pointer ${n.read ? "" : "border-[#83B68B]/60"}`} data-testid={`notice-${n.id}`}>
                <div className="flex flex-wrap items-center gap-2 text-xs opacity-60">
                  {n.pinned && <span className="inline-flex items-center gap-1 text-[#83B68B]"><Pin className="w-3 h-3" /> Pinned</span>}
                  <span>{fmt(n.created_at)} · {n.created_by}</span>
                  {n.audience_age_groups?.length > 0 && <span>· for {n.audience_age_groups.join(", ")}</span>}
                  {!n.read && <span className="ml-auto text-[9px] tracking-widest uppercase px-2 py-0.5 rounded bg-[#83B68B] text-white" data-testid={`notice-unread-${n.id}`}>New</span>}
                </div>
                <h2 className="font-display font-bold text-lg mt-1">{n.title}</h2>
                <p className="text-sm whitespace-pre-wrap mt-1 opacity-90">{n.body}</p>
                {n.link && <a href={n.link} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} className="text-xs text-[#83B68B] underline inline-flex items-center gap-1 mt-2"><ExternalLink className="w-3 h-3" /> {n.link}</a>}
              </article>
            ))}
          </div>
        )}
    </div>
  );
}
